import { _api } from '@/utils/apiAxios';
import axios from 'axios';
const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const state = {
  status: {
    loading: false,
    success: false,
    error: false,
  },
  currentStoredMethods: [],
  selectedMethod: {},
};

const getters = {};

const mutations = {
  setCurrentStoredMethods(state, currentStoredMethods) {
    state.currentStoredMethods = currentStoredMethods;
  },
  setStatus(state, status) {
    state.status = status;
  },
  setSelectedMethod(state, selectedMethod) {
    state.selectedMethod = selectedMethod;
  },
};

const actions = {
  getStoredPayouts({ commit }, currentMethod) {
    commit('setStatus', { loading: true });
    commit('setCurrentStoredMethods', []);
    commit('setSelectedMethod', {});

    _api
      .get('payout/stored/' + currentMethod, { cancelToken: source.token })
      .then(res => {
        if (res.data.IsSuccess) {
          commit('setCurrentStoredMethods', res.data.Data);
        }
      })
      .finally(() => {
        commit('setStatus', { loading: false });
      });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
